import React, {useEffect} from 'react';
import {View, iURL} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/quickCash';
import QuickCashModel from '../models/quickCash.m';
import {apiback} from '../../../config';
import widgetsHelper from 'utils/getWidget.helper';
import cookie from '../../../helpers/vendor/cookie';

const utmMarks = [
        'utm_manager',
        'utm_source',
        'utm_comment',
        'utm_campaign',
        'utm_medium',
        'utm_term',
        'utm_content'
    ],
    CPA_PROGRAM_SOURCE = 'CPA',
    REFERAL_PROGRAM_SOURCE = 'REFERAL';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            selectedType: 'loyal',
            model: {},
            showModal: false,
            isUtm: new URLSearchParams(this.props.location.search).get('utm_source'),
            mode: 'info',
            orderBtnMode: false,
            where_by: ['path'],
            search_by: ['/credit/quick_cash'],
            widgets: []
        };
        this.scrollTimer = null;
        this.setupCalcType = this.setupCalcType.bind(this);
        this.toggleMode = this.toggleMode.bind(this);
        this.scrollToCalculator = this.scrollToCalculator.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.widgetsHelper = widgetsHelper;
        this.scrollToCalc = this.scrollToCalc.bind(this);
        return this;
    }

    toggleModal(setLoanValues = true) {
        this.setState(prevState => ({
            showModal: !this.state.showModal,
            ...(setLoanValues && {
                loanSum: this.getModel().getCreditSum(),
                loanTerm: this.getModel().getCreditTerm()
            }),
            ...(prevState.showModal === true && {
                loanSum: null,
                loanTerm: null
            })
        }));
    }

    componentDidMount() {
        this.utmParams = this.saveUTMParams();
        this.widgetsHelper.getWidgets.call(this);
        this.updateModeBasedOnURL();
        this.scrollToBlock();
    }

    updateModeBasedOnURL() {
        const params = new URLSearchParams(window.location.search);
        if (
            params.has('cashcomfort') ||
            params.has('addcash') ||
            params.has('salaryplus') ||
            params.has('zero')
        ) {
            this.setState({mode: 'special_offers'});
        }
    }

    scrollToBlock() {
        const params = new URLSearchParams(window.location.search);
        const targetIds = ['cashcomfort', 'addcash', 'salaryplus', 'zero'].filter(param =>
            params.has(param)
        );
        if (!targetIds.length) return;

        const maxAttempts = 50;
        const intervalTime = 300;
        let attempts = 0;

        const checkAndScroll = () => {
            targetIds.forEach((id, index) => {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({block: 'start', behavior: 'smooth'});
                    targetIds.splice(index, 1);
                }
            });

            attempts++;

            if (!targetIds.length || attempts >= maxAttempts) {
                clearInterval(this.scrollTimer);
                this.scrollTimer = null;
            }
        };

        if (this.scrollTimer) {
            clearInterval(this.scrollTimer);
        }

        this.scrollTimer = setInterval(checkAndScroll, intervalTime);
    }

    removeAnchorFromUrl() {
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
    }

    toggleMode = mode => {
        this.setState({mode: mode});
        this.removeAnchorFromUrl();
    };

    componentWillMount() {
        document.addEventListener('switchCalcMode', this.setupCalcType);
        fetch(apiback('QUICK_CASH'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new QuickCashModel(json.data, this.state.selectedType)
                })
            )
            .then(this.scrollToCalc);
        // .catch(x => console.log("error:", x)); todo добавить обработчик
    }

    componentWillUnmount() {
        document.removeEventListener('switchCalcMode', this.setupCalcType);
        this.removeAnchorFromUrl();
        if (this.scrollTimer) {
            clearInterval(this.scrollTimer);
            this.scrollTimer = null;
        }
    }
    scrollToCalc = () => {
        const currentURL = window.location.href;
        const targetElement = document.querySelector('.credit-calculator');
        if (currentURL.includes('quick_cash/calc')) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            this.setState({
                orderBtnMode: true
            });
        }
    };
    scrollToCalculator = () => {
        this.setState({mode: 'info'}, () => {
            document.querySelector('.credit-calculator').scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    };

    setupCalcType(e) {
        const model = this.state.model,
            mode = e.detail.mode;

        model.switchType(mode);
        this.setState({
            selectedType: mode
        });
    }

    saveUTMParams() {
        const params = iURL.getSearchParams();
        let result = {};

        if (params.utm_source) {
            result = this._getUTMMarks(params);

            //  todo remove after 2-3 versions (21.04.2025)
            // } else if (params.utm_source) {
            //     result = this._setUTMMarks(params);
            //     this.props.history.push(this.props.location.pathname);
        } else if (cookie('utm_source') === CPA_PROGRAM_SOURCE) {
            result = this._getUTMMarks();
        }

        return result;
    }

    _getUTMMarks(storage = cookie) {
        const result = {};

        for (const name of utmMarks) {
            if (storage === cookie) {
                result[name] = cookie(name) || '';
            } else {
                result[name] = storage[name] || '';
            }
        }

        return result;
    }

    _setUTMMarks(data = {}) {
        for (const name of utmMarks) {
            if (data[name]) {
                cookie(name, data[name], {expires: 30, path: '/'});
            } else {
                cookie(name, null, {path: '/'});
            }
        }

        return data;
    }

    static displayName = 'Credit.Views.QuickCash';

    static contextTypes = {
        app: PropTypes.object
    };
}
